import Icon from 'veui/components/Icon'

Icon.register({
  'image-add': {
    paths: [
      {
        d: 'M27 4.5v1H4a2.5 2.5 0 00-2.5 2.34V30a2.5 2.5 0 002.34 2.5H32a2.5 2.5 0 002.5-2.34V13h1v17a3.5 3.5 0 01-3.3 3.5H4a3.5 3.5 0 01-3.5-3.3V8a3.5 3.5 0 013.3-3.5H27zM14.43 16.44c.18.13.34.27.49.44l.13.17L20 24.13 22.97 20a2.5 2.5 0 013.94-.17l.12.17 3.38 4.72a.5.5 0 01-.76.65l-.06-.07-3.37-4.72a1.5 1.5 0 00-2.35-.11l-.1.1-3.36 4.73a.5.5 0 01-.7.12.5.5 0 01-.13-.13l-5.35-7.65a1.5 1.5 0 00-2.37-.12l-.09.12-5.36 7.66a.5.5 0 01-.86-.5l.04-.08 5.36-7.66a2.5 2.5 0 013.48-.61zM27 9a3 3 0 110 6 3 3 0 010-6zm8-8.5c.28 0 .5.22.5.5v4h4a.5.5 0 110 1h-4v4a.5.5 0 11-1 0V6h-4a.5.5 0 110-1h4V1c0-.28.22-.5.5-.5z',
        fill: 'currentColor'
      }
    ],
    width: '40',
    height: '34'
  }
})
